import Link from "next/link";
import type { ComponentProps } from "react";
import { isCrossZoneHref } from "@/lib/zones";

type ZoneLinkProps = Omit<ComponentProps<typeof Link>, "href"> & {
	href: string;
};

/**
 * Drop-in replacement for next/link in shared chrome (navbar, footer, content
 * pages) that renders a plain <a> when the href targets a DIFFERENT path zone
 * (see src/lib/zones.ts): cross-zone <Link> prefetches a foreign build's RSC
 * payload — a wasted worker invocation per viewport render — and hard-loads on
 * click anyway. Same-zone hrefs keep full <Link> soft navigation.
 */
export function ZoneLink({
	href,
	prefetch,
	replace,
	scroll,
	...rest
}: ZoneLinkProps) {
	if (isCrossZoneHref(href)) {
		return <a href={href} {...rest} />;
	}
	return (
		<Link
			href={href}
			prefetch={prefetch}
			replace={replace}
			scroll={scroll}
			{...rest}
		/>
	);
}
